var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};



















































pug_mixins["label-with-help"] = pug_interp = function(text, topic){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"label-with-help\" layout=\"row\"\u003E\u003Clabel\u003E" + (pug.escape(null == (pug_interp = text) ? "" : pug_interp)) + "\u003Chelp-mate" + (pug.attr("topic", topic, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E";
};



















pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_html = pug_html + "\u003Cmd-progress-linear ng-if=\"!vm.investor\" md-mode=\"indeterminate\"\u003E\u003C\u002Fmd-progress-linear\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"md-padding\" ng-cloak\u003E\u003Cdiv class=\"container\" flex layout-align=\"start center\" ng-if=\"vm.investor\"\u003E\u003Cdiv layout=\"column\"\u003E\u003Cdiv class=\"email-verification\" ng-if=\"!vm.emailVerified\" ng-cloak\u003E\u003Chelp-box\u003E\u003Ch2\u003E\u003Cmd-icon class=\"warning\"\u003Ewarning\u003C\u002Fmd-icon\u003E You have not yet verified your email address\u003C\u002Fh2\u003E\u003Cp\u003EPlease check your email for a verification request - it may be in your \"Junk\" mail folder. You will not be able to invest until your address has been verified.\u003C\u002Fp\u003E\u003Cmd-button class=\"md-raised md-warn ios-rendering-fix\" ng-click=\"vm.resendVerificationEmail()\" aria-label=\"Resend verification email\"\u003EResend Verification Email\u003C\u002Fmd-button\u003E\u003C\u002Fhelp-box\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pending-message\" ng-if=\"vm.pending &gt; 0\"\u003E\u003Chelp-box\u003E\u003Ch2\u003EAuction complete\u003C\u002Fh2\u003E\u003Cp\u003ECongratulations, you have a winning bid in a successful loan auction. Once the loan has\nbeen issued you will be able to track your investment in the Your loan investments table below.\n\u003C\u002Fp\u003E\u003C\u002Fhelp-box\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"investor-summary\" layout=\"column\" flex-gt-sm\u003E\u003Cdiv class=\"allocations\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" layout-xs=\"column\"\u003E\u003Cul class=\"overview\" flex-gt-xs=\"50\" flex-xs=\"100\"\u003E\u003Cli class=\"available-funds\" layout=\"row\"\u003E\u003Clabel class=\"clicky\" flex=\"40\" flex-lg=\"30\" flex-xl=\"25\" ui-sref=\"investorDashboard.manageFunds\"\u003EAvailable funds:\u003C\u002Flabel\u003E\u003Chelp-mate topic=\"available-funds\"\u003E\u003C\u002Fhelp-mate\u003E\u003Cdiv class=\"value\" flex\u003E{{ vm.available | asCurrency }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"color-key\" flex=\"10\" layout=\"row\" layout-align=\"center\"\u003E\u003Cdiv class=\"available\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"reserved-funds\" layout=\"row\"\u003E\u003Clabel class=\"clicky\" flex=\"40\" flex-lg=\"30\" flex-xl=\"25\" ui-sref=\"investorDashboard.bids\"\u003ELive bids:\u003C\u002Flabel\u003E\u003Chelp-mate topic=\"live-bids\"\u003E\u003C\u002Fhelp-mate\u003E\u003Cdiv class=\"value\" flex\u003E\u003Cspan ng-if=\"vm.auctionsResolved\"\u003E{{ vm.liveBids | asCurrency }}\u003C\u002Fspan\u003E\u003Cmd-progress-circular ng-if=\"!vm.auctionsResolved\" md-mode=\"indeterminate\" md-diameter=\"12\"\u003E\u003C\u002Fmd-progress-circular\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"color-key\" flex=\"10\" layout=\"row\" layout-align=\"center\"\u003E\u003Cdiv class=\"reserved\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"pending-funds\" layout=\"row\"\u003E\u003Clabel class=\"clicky\" flex=\"40\" flex-lg=\"30\" flex-xl=\"25\" ui-sref=\"investorDashboard.bids\"\u003EPending:\u003C\u002Flabel\u003E\u003Chelp-mate topic=\"pending-bids\"\u003E\u003C\u002Fhelp-mate\u003E\u003Cdiv class=\"value\" flex\u003E\u003Cspan ng-if=\"vm.auctionsResolved\"\u003E{{ vm.pendingBids | asCurrency }}\u003C\u002Fspan\u003E\u003Cmd-progress-circular ng-if=\"!vm.auctionsResolved\" md-mode=\"indeterminate\" md-diameter=\"12\"\u003E\u003C\u002Fmd-progress-circular\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"color-key\" flex=\"10\" layout=\"row\" layout-align=\"center\"\u003E\u003Cdiv class=\"pending\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"invested-funds\" layout=\"row\"\u003E\u003Clabel class=\"clicky\" flex=\"40\" flex-lg=\"30\" flex-xl=\"25\" ui-sref=\"investorDashboard.loanParts\"\u003EInvestments:\u003C\u002Flabel\u003E\u003Chelp-mate topic=\"total-invested\"\u003E\u003C\u002Fhelp-mate\u003E\u003Cdiv class=\"value\" flex\u003E{{ vm.invested | asCurrency }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"color-key\" flex=\"10\" layout=\"row\" layout-align=\"center\"\u003E\u003Cdiv class=\"invested\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"total\" layout=\"row\"\u003E\u003Clabel flex=\"40\" flex-lg=\"30\" flex-xl=\"25\"\u003EP2P Total:\u003C\u002Flabel\u003E\u003Cdiv class=\"value\" flex\u003E\u003Cspan ng-if=\"vm.auctionsResolved\"\u003E{{ vm.total | asCurrency }}\u003C\u002Fspan\u003E\u003Cmd-progress-circular ng-if=\"!vm.auctionsResolved\" md-mode=\"indeterminate\" md-diameter=\"12\"\u003E\u003C\u002Fmd-progress-circular\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"no-box\" flex=\"10\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cdiv class=\"chart\" ng-if=\"vm.p2p\" flex-gt-xs=\"50\" flex-xs=\"100\"\u003E\u003Cdiv class=\"chart-container\"\u003E\u003Cchartist class=\"ct-square shadow allocations ios-rendering-fix\" chartist-data=\"vm.chartData\" chartist-events=\"vm.chartEvents\" chartist-chart-options=\"vm.chartOptions\" chartist-chart-type=\"Pie\"\u003E\u003C\u002Fchartist\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"returns\" layout=\"row\" layout-align-gt-xs=\"start start\" layout-xs=\"column\"\u003E\u003Cdiv class=\"panel\" flex-gt-md=\"30\" flex-md=\"25\" flex-sm=\"25\" flex-xs=\"100\"\u003E\u003Cdiv layout=\"row\" layout-align=\"start center\" layout-align-xs=\"center\"\u003E";
pug_mixins["label-with-help"]("Total interest earned", "total-interest-earned");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"interest\" layout=\"row\" layout-align-xs=\"center\"\u003E\u003Cdiv class=\"value\"\u003E{{ vm.interest | asCurrency }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"panel\" flex-gt-md=\"30\" flex-md=\"25\" flex-sm=\"25\" flex-xs=\"100\"\u003E\u003Cdiv layout=\"row\" layout-align=\"start center\" layout-align-xs=\"center\"\u003E";
pug_mixins["label-with-help"]("Net yield on investments", "net-yield-on-investments");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"yield\" layout=\"row\" layout-align-xs=\"center\"\u003E\u003Cdiv class=\"value\"\u003E{{ vm.p2pYield }}\u003C\u002Fdiv\u003E\u003Cdiv layout=\"column\" layout-align=\"center\"\u003E\u003Cdiv class=\"symbol\"\u003E%\u003C\u002Fdiv\u003E\u003Cdiv class=\"pa\"\u003Epa\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"no-pending-message\" ng-if=\"vm.p2p\" layout=\"column\" layout-gt-sm=\"row\"\u003E\u003Cdiv flex-gt-xs=\"50\" flex-xs=\"100\"\u003E\u003Cp\u003ETo check out the investment opportunities available right now:\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv flex-gt-xs=\"50\" flex-xs=\"100\" layout=\"row\" layout-align=\"center center\"\u003E\u003Cmd-button class=\"md-raised md-accent ios-rendering-fix marketplace-link\" ui-sref=\"marketplace\" ui-sref-opts=\"{reload: true}\" aria-label=\"P2P Marketplace\"\u003EGo to the P2P Marketplace\u003C\u002Fmd-button\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"loan-parts\" ng-if=\"vm.investor &amp;&amp; vm.p2p\"\u003E\u003Cloan-parts investor=\"vm.investor\"\u003E\u003C\u002Floan-parts\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bids\" ng-if=\"vm.investor &amp;&amp; vm.p2p\"\u003E\u003Ccurrent-bids investor=\"vm.investor\"\u003E\u003C\u002Fcurrent-bids\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
});}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;